<script>
import VSelect from '@alfsnd/vue-bootstrap-select';
import { BTable, BFormDatepicker, BInputGroup, BFormInput, BInputGroupAppend, BModal, BFormSelect, BButton } from 'bootstrap-vue'
// import ToggleButton from 'vue-js-toggle-button';
import DibbleTranslation from "../../translation/translation";
import DibbleAPI from "../../api";
import DibbleJS from "../../dibble";
import Helper from '../../appHelper';

export default {
    name: "Feedbacks",
    components: {
        VSelect, BTable, BFormDatepicker, BFormSelect, BButton, 
        BInputGroup, BFormInput, BInputGroupAppend, BModal
    },
    data() {
        return {            
            translate: DibbleTranslation,
            feedbackDetailsModal: {
                isOpen: false,
                isNew: true,
                title: DibbleTranslation.trans('pinker.editFeedback'),
                feedback: {
                    id: 0,
                    number: 0,
                    name: 'Demo feedback',
                    femaleName: 'Demo feedback female',
                    color: "#ff0000",
                    colorId: 0,
                    type: 3,
                    isActive: true
                }
            },            
            showInfoModal: false,
            formUser:[],
            countries: [
                {
                    value: null,
                    text: "-- None --"
                }
            ],
            totalUser: 0,
            user_status: [],
            filter_from_date: '',
            filter_to_date: '',
            filter_to_date_formatted: '',
            filter_to_date_selected: '',
            search: {
                keyword: '',
                status: {},
                country: {
                    value: null,
                    text: "-- None --"
                },
            },
            fields: [
                { key: 'id', label: DibbleTranslation.trans('pinker.feedbackNumber'), sortable: true },
                { key: 'name', label: DibbleTranslation.trans('pinker.feedbackName'), sortable: true },
                { key: 'female_name', label: DibbleTranslation.trans('pinker.feedbackFemaleName'), sortable: true },
                { key: 'color', label: DibbleTranslation.trans('pinker.feedbackColor'), sortable: true },
                { key: 'type', label: DibbleTranslation.trans('pinker.feedbackType'), sortable: true },
                { key: 'is_active', label: DibbleTranslation.trans('pinker.isActive'), sortable: true},
                { key: 'edit', label: DibbleTranslation.trans('pinker.edit'), sortable: false },
            ],            
            selectedType: null,
            selectedStatus: null,
            selectedLanguage: Helper.getAppLang(),
            typeOptions: [
                { value: null, text: DibbleTranslation.trans('pinker.selectFeedbackType') },
                { value: 3, text: DibbleTranslation.trans('pinker.forPrivate')},
                { value: 4, text: DibbleTranslation.trans('pinker.forBusiness')}
            ],
            statusOptions: [
                { value: null, text: DibbleTranslation.trans('pinker.selectFeedbackStatus')},
                { value: true, text: DibbleTranslation.trans('pinker.active')},
                { value: false, text: DibbleTranslation.trans('pinker.inActive')}
            ],
            langOptions: [
                { value: 'he', text: DibbleTranslation.trans('pinker.Hebrew') },
                { value: 'en', text: DibbleTranslation.trans('pinker.English') }
            ],
            users: [],
            feedbacks: [],
            sourceFeedbacks: [],
            colors: [],
            pagination: {
                currentPage: 1,
                totalPage: 0
            },
            statisticForm: {
                isOpenStatisticModal: false,
                isAllApp: true,
                title: "",
                total_memo: 0,
                total_safe_memo: 0,
                total_space_memo: 0,
                total_ghost_memo: 0,
                total_complete_questionair: 0,
                total_share_memo: 0,
                total_report_to_user: 0,
                total_repost_from_user: 0,
                total_turnover_all: 0,
                total_turnover_each_subscription: 0,
            }
        }
    },
    mounted() {
        const scrollContent = document.getElementById('scroll-main-content')
        scrollContent.style.height = window.innerHeight*0.8 +  "px"
    },
    created() {
        this.loadFeedbacks();
        this.loadColorList();
    },
    methods: {
        moment(value) {
            return this.$moment(value)
        },
        showFeedbackModal(feedbackItem, isNew) {
            this.feedbackDetailsModal.isNew = isNew;
            if (this.feedbackDetailsModal.isNew) {
                this.feedbackDetailsModal.title = this.translate.trans('pinker.createNewFeedback')
            } else {
                this.feedbackDetailsModal.title = this.translate.trans('pinker.editFeedback')
                this.feedbackDetailsModal.feedback.id = feedbackItem.id
               this.feedbackDetailsModal.feedback.name = feedbackItem.name
                this.feedbackDetailsModal.feedback.femaleName = feedbackItem.female_name
                this.feedbackDetailsModal.feedback.type = feedbackItem.type
                // this.feedbackDetailsModal.feedback.colorId = this.getColorId(feedbackItem.color)
                  this.feedbackDetailsModal.feedback.colorId = feedbackItem.color
                this.feedbackDetailsModal.feedback.isActive = feedbackItem.is_active
            }
            this.feedbackDetailsModal.isOpen = true
        },
        closeFeedbackModal() {
            this.feedbackDetailsModal.isOpen = false
        },
        showFeedbacklist(userId) {
            alert(userId)
        },
        toggleCurrentFeedback () {
            this.feedbackDetailsModal.feedback.isActive = !this.feedbackDetailsModal.feedback.isActive
        },
        loadColorList () {
            const params = {
                '#request': DibbleAPI.api.admin.getColorScheme
            };

            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, (responseData) =>{
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                    this.colors = responseData.color_scheme;                
                } else {
                    DibbleJS.toastErrorMessage(responseData.message);
                }
            })
        },
        chooseColor (colorId) {
            console.log(colorId)
            this.feedbackDetailsModal.feedback.colorId = colorId
        },
        getBackgroundColorCss (color) {
            if (color.id === this.feedbackDetailsModal.feedback.colorId) {
                return "border: solid 2px red; background-color: " + color.color;
            } else {
                return "background-color: " + color.color;
            }            
        },
        saveFeedback() {
            if (this.feedbackDetailsModal.feedback.colorId === 0) {
                this.feedbackDetailsModal.feedback.colorId = this.colors[0].id
            }
            if (this.feedbackDetailsModal.isNew) {
                const params = {
                    "#request": DibbleAPI.api.admin.addChareacterTraits,
                    name: this.feedbackDetailsModal.feedback.name,
                    female_name: this.feedbackDetailsModal.feedback.femaleName,
                    color_id: this.feedbackDetailsModal.feedback.colorId,
                    user_type: this.feedbackDetailsModal.feedback.type,
                    is_active: true,
                    language: Helper.getAppLang()
                }
                this.feedbackDetailsModal.isOpen = false;
                DibbleJS.showLoader();
                DibbleJS.callApiRequest(params, (responseData) =>{
                    DibbleJS.hideLoader();
                    DibbleJS.toastErrorMessage(responseData.message);
                    if (DibbleAPI.isResponseSuccess(responseData)) {
                        this.loadFeedbacks();
                    }
                })
            } else {
                const params = {
                    "#request": DibbleAPI.api.admin.updateCharacterTraits,
                    character_trait_id: this.feedbackDetailsModal.feedback.id,
                   name: this.feedbackDetailsModal.feedback.name,
                    female_name: this.feedbackDetailsModal.feedback.femaleName,
                    color_id: this.feedbackDetailsModal.feedback.colorId,
                    user_type: this.feedbackDetailsModal.feedback.type,
                    is_active: this.feedbackDetailsModal.feedback.isActive,
                    language: Helper.getAppLang()
                }
                this.feedbackDetailsModal.isOpen = false;
                DibbleJS.showLoader();
                DibbleJS.callApiRequest(params, (responseData) =>{
                    DibbleJS.hideLoader();
                    DibbleJS.toastErrorMessage(responseData.message);
                    this.loadFeedbacks();
                    // if (DibbleAPI.isResponseSuccess(responseData)) {
                    // }
                })
            }
        },
        loadFeedbacks() {
            const params = {
                '#request': DibbleAPI.api.admin.getCharacterTraits,
                // active_filters: false,
                // is_active: false,
                user_type: this.selectedType,
                sort_direction: false,
                language: Helper.getAppLang()
            };

            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, this._onLoadFeedbacksSuccess)
        },
        _onLoadFeedbacksSuccess(responseData) {
            DibbleJS.hideLoader();
            if (DibbleAPI.isResponseSuccess(responseData)) {
                this.sourceFeedbacks = responseData.character_traits;
                this.feedbacks = responseData.character_traits;                
            } else {
                DibbleJS.toastErrorMessage(responseData.message);
            }
        },
        onFilterChange (filterName) {
            if (filterName === "type") {
                if (this.selectedType == null) {
                    this.feedbacks = this.sourceFeedbacks
                } else {
                    const tempList = []
                    this.sourceFeedbacks.map (item  => {
                        if (item.type === this.selectedType) {
                            tempList.push(item)
                        }
                        return item;
                    })
                    this.feedbacks = tempList
                }
            } else if (filterName === "status") {
                if (this.selectedStatus == null) {
                    this.feedbacks = this.sourceFeedbacks
                } else {
                    const tempList = []
                    this.sourceFeedbacks.map (item  => {
                        if ((item.is_active === 1) === this.selectedStatus) {
                            tempList.push(item)
                        }
                        return item;
                    })
                    this.feedbacks = tempList
                }
            } else if (filterName === "lang") {
                Helper.setAppLang(this.selectedLanguage)
                this.loadFeedbacks()
            }
        },
        searchUser (searhKey) {
            const tempUserList = []
            this.sourceUsers.map((item, index) => {
                const fullname = item.first_name + item.last_name
                if (fullname.toLowerCase().includes(searhKey.toLowerCase()) 
                    || item.email.toLowerCase().includes(searhKey.toLowerCase())){
                        tempUserList.push(item)
                }
                return item;
            })
            this.users = tempUserList
        },
        showStatistic (dataItem, isAppStatistic) {
            this.statisticForm.isAllApp = isAppStatistic
            if (isAppStatistic) {
                this.statisticForm.title = this.translate.trans('users.statistic.title')+ ": " + this.translate.trans('users.statistic.all')
                console.log("isAppStatistic")
                this.loadAppStatistic((data) => {                
                    this.statisticForm.isOpenStatisticModal = true
                    this.statisticForm.total_memo = data.number_of_memories
                    this.statisticForm.total_safe_memo = data.number_of_safe_memories
                    this.statisticForm.total_space_memo = data.number_of_space_memories
                    this.statisticForm.total_ghost_memo = data.number_of_ghost_memories
                    this.statisticForm.total_share_memo = data.number_of_shared_memories
                    this.statisticForm.total_report_to_user = data.number_of_user_has_been_reported
                    this.statisticForm.total_repost_from_user = data.number_of_user_reported_other_users
                    this.statisticForm.total_complete_questionair = data.questionnaire_is_complete     
                    this.statisticForm.total_turnover_all = data.subscription     
                    this.statisticForm.total_turnover_each_subscription = data.subscription_plan     
                })
            } else {
                this.statisticForm.title = this.translate.trans('users.statistic.title') + ": " + dataItem.first_name + " " + dataItem.last_name
                this.loadUserStatistic(
                    dataItem.user_id, 
                    (data) => {                        
                        this.statisticForm.isOpenStatisticModal = true
                        this.statisticForm.total_memo = data.user_statistics.number_of_memories
                        this.statisticForm.total_safe_memo = data.user_statistics.number_of_safe_memories
                        this.statisticForm.total_space_memo = data.user_statistics.number_of_space_memories
                        this.statisticForm.total_ghost_memo = data.user_statistics.number_of_ghost_memories
                        this.statisticForm.total_share_memo = data.user_statistics.number_of_shared_memories
                        this.statisticForm.total_report_to_user = data.user_statistics.number_of_user_has_been_reported
                        this.statisticForm.total_repost_from_user = data.user_statistics.number_of_user_reported_other_users
                        this.statisticForm.total_complete_questionair = data.user_statistics.is_complete                        
                    }
                )
            }
        },
        loadUserStatistic (userId, callback) {
            DibbleJS.showLoader()
            const rq = {
                "#request": DibbleAPI.api.getUserStatistic,
                user_id: userId
            }
            DibbleJS.callApiRequest( 
                rq,
                (data) => {
                    DibbleJS.hideLoader()
                    if (DibbleAPI.isResponseSuccess(data)){
                        callback(data)
                    } else {
                        DibbleJS.toastErrorMessage(data.message)
                    }
                }
            )
        },
        loadAppStatistic (callback) {
            DibbleJS.showLoader()
            const rq = {
                "#request": DibbleAPI.api.getAllUserStatistic
            }
            DibbleJS.callApiRequest( 
                rq,
                (data) => {
                    DibbleJS.hideLoader()
                    if (DibbleAPI.isResponseSuccess(data)){
                        callback(data)
                    } else {
                        DibbleJS.toastErrorMessage(data.message)
                    }
                }
            )
        },
        closeStatisticModal () {
            this.statisticForm.isOpenStatisticModal = false
        },
        checkShowHeritageButton (item) {
            if ((item.timeline_email != null && item.timeline_email !== '') 
                || (item.safe_box_email != null && item.safe_box_email !== '')) {                    
                    return item.heritage_send_status
            } else {
                return ""
            }
        },
        updateHeritage (item) {
            const params = {
                "#request": DibbleAPI.api.sendHeritage,
                user_id: item.user_id
            };
            console.log(JSON.stringify(params))
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, 
            (data) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(data)) {
                    DibbleJS.toastSuccessMessage(data.message);
                    this.loadUsers()
                } else {
                    DibbleJS.toastErrorMessage(data.message);
                }
            })
        },
        cancelHeritage (item) {
            const params = {
                "#request": DibbleAPI.api.cancelSendHeritage,
                user_id: item.user_id
            };
            console.log(JSON.stringify(params))
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, 
            (data) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(data)) {
                    DibbleJS.toastSuccessMessage(data.message);
                    this.loadUsers()
                } else {
                    DibbleJS.toastErrorMessage(data.message);
                }
            })
        },
        getColorId (colorString) {
            let colorId = 0;
            this.colors.map(item => {
                if (item.color === colorString) {
                    colorId = item.id
                }
                return item;
            })
            return colorId;
        },
        toggleStatus(item) {
            console.log('toggleStatus: ' + item.is_active)
            let activeValue = false;
            if (item.is_active === 1) {
                activeValue = false
            } else {
                activeValue = true
            }
            const params = {
              '#request': DibbleAPI.api.admin.updateCharacterTraitsStatus,
              character_trait_id: item.id,
              is_active: activeValue
            };
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                  DibbleJS.toastSuccessMessage(responseData.message);
                  this.loadFeedbacks();
                } else {
                  DibbleJS.toastErrorMessage(responseData.message);
                }
            })
        }
    }
}
</script>

<style>
    .user-image {
        width: 40px;
        height: 40px;
    }
    .v-dropdown-container {
        max-height: 250px;
        overflow-y: scroll;
    }
    .small-text-box {
        width: 50px
    }
    .medium-text-box {
        width: 120px
    }
    .circle-color {
        width: 20px;
        height: 20px;
        border-radius: 10px;
        background-color: brown;
    }  
</style>

<template src="./Templates/Feedbacks.html"></template>


